import { ValuableModel } from '../../models/ValuableModel'

export class SchemaTypedSchemaModel extends ValuableModel {}

declare global {
  export interface RehajeViewModels {
    'Schema.TypedSchema': SchemaTypedSchemaModel
  }
}
